<template>
  <div class="hello" ref="myHello" v-dragscroll>
    <!-- 占位符 -->
    <div class="elStep" v-for="(item, i) in upContentList" :key="item.id">
      <div class="el-step_line">
        <i class="el-step__line-inner"></i>
      </div>
      <div class="el-step_head" @click="fun(item, i, $event)">
        <div class="el-date date_active" v-if="item.day == presentDate && monthDate == currentMonth">今</div>
        <!-- 日期 -->
        <div class="el-date " v-if="item.historyBody == '' && (item.day != presentDate || monthDate != currentMonth)"
          style="color: #ccc;">{{ item.day }}</div>

        <!-- 日期 -->
        <div class="el-date" v-else-if="item.historyBody != '' && (item.day != presentDate || monthDate != currentMonth)"
          :class="{ date_active: myCurrentDate == item.day }">{{ item.day }}</div>
        <!-- 原点 -->
        <div class="el-icon" :class="{ active: myCurrentDate == item.day }"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, toRefs, ref, onMounted, defineEmits, watch } from 'vue'
import dragscroll from '../../utils/directives'
export default defineComponent({
  props: {
    // 日期
    currentDate: {
      type: Number,
    },
    // 当月天数
    daysInCurrentMonth: {
      type: Number,
    },
    // 月份
    monthDate: {
      type: Number,
    },
    // 内容
    upContentList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  directives: {
    dragscroll
  },
  setup(props, { emit }) {
    const { currentDate, daysInCurrentMonth, upContentList } = toRefs(props)
    const currentMonth = ref('')
    const myCurrentDate = ref('')
    const myHello = ref(null)
    // 当前的日期 (定值)
    const presentDate = ref(0)
    const now = new Date();
    let month = now.getMonth() + 1; // 当前月份
    presentDate.value = now.getDate();
    // const emit = defineEmits(['upDay'])
    onMounted(() => {
      nextTick(() => {
        myCurrentDate.value = props.currentDate
        if (myHello.value) {
          myHello.value.scrollLeft = 15 * currentDate.value + ''
          console.log(myHello.value.scrollLeft);
        }
      })
      const now = new Date();
      currentMonth.value = now.getMonth() + 1; // 月份是从0开始的，所以要加1
      console.log(presentDate)
    })
    const fun = (item, i, e) => {
      myCurrentDate.value = item.day;
      console.log(month);
      emit('upDay', item.day)
      myHello.value.scrollLeft = 15 * item.day + ''
      
    }

    //   watch([() => props.upContentList, ()=>props.monthDate],(val) => {
    //     console.log(val);
    //   },
    // )
    watch(() => props.monthDate, (val) => {
    // console.log(props.currentDate);
    myCurrentDate.value = currentDate.value
    myHello.value.scrollLeft = 15 * currentDate.value + ''
    // console.log(val);
    
  },
  )


    return {
      myHello,
      now,
      month,
      fun,
      presentDate,
      myCurrentDate,
      currentMonth
    }

  }
})
</script>
<style scoped>
.hello {
  /* margin: 20px auto 0; */
  width: 1000px;
  overflow: hidden;
  display: flex;
  background-color: #fff;
}

.elStep {
  width: 50px;
  position: relative;
  font-size: 16px
}

.el-step_line {
  height: 2px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 25px;
  z-index: 1;
}

.el-step__line-inner {
  display: block;
  width: 50px;
  border-width: 1px;
  border-style: solid;
  border-color: #E9E9E9;
  box-sizing: border-box;
}

.el-step_head {
  width: 50px;
  height: 80px;
  /* background-color: red; */
  line-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.el-icon {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid #E9E9E9;
  z-index: 999;
  display: inline-flex;
  margin-top: 10px;
  align-items: center;
}

.el-date {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #222222;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  height: 40px;
  line-height: 40px;
  user-select: none;
}

.date_active {
  font-size: 18px;
  color: #CE2321;
  font-size: 800;
}


.active {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: rgb(247, 7, 7);
  border: none;
  box-shadow: 0px 0px 5px 8px #f5d3d3;
  /* 阴影 */
  margin-top: 7px;
}
</style>